import { cx } from '@/lib/cx';
import { copy } from './copy';
import styles from './Spinner.module.css';

const SPOKES = [0, 1, 2, 3, 4, 5, 6, 7] as const;

/** Indicador de atividade estilo macOS (8 raios, rotação em passos). */
export function Spinner({
  size = 16,
  label = copy.spinner,
  decorative = false,
  className,
}: {
  size?: number;
  label?: string;
  /** true quando o contexto já anuncia o carregamento (ex.: botão com aria-busy). */
  decorative?: boolean;
  className?: string;
}) {
  return (
    <svg
      className={cx(styles.spinner, className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role={decorative ? undefined : 'progressbar'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
    >
      {SPOKES.map((i) => (
        <line
          key={i}
          x1="12"
          y1="3"
          x2="12"
          y2="7.5"
          transform={`rotate(${i * 45} 12 12)`}
          style={{ opacity: 1 - i * 0.11 }}
        />
      ))}
    </svg>
  );
}
